/* Rad Dad 2.0 Rewards page behaviour (design handoff 2026-09-08). No dependencies.
   1. Questions accordion   2. Sticky enrolment bar
   Same shape as rda-2.js: every feature no-ops when its markup is absent, and the
   whole thing re-runs on Shopify theme-editor section loads. Loaded sitewide with
   defer, so on every other page both functions find nothing and return. */
(function () {
  'use strict';

  /* ---- Questions. One panel open at a time; the first is open on load. ----
     The handoff specifies a real <button> with aria-expanded bound to state, so
     this is not <details name>: that would drop the ARIA contract and the +/-
     indicator, and its exclusive-accordion behaviour is not universal yet. */
  function faq(scope) {
    scope.querySelectorAll('[data-rda2-rw-faq]').forEach(function (root) {
      if (root.dataset.rda2RwBound) return;
      root.dataset.rda2RwBound = '1';
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-rda2-rw-row]'));
      if (!rows.length) return;

      function paint(openIndex) {
        rows.forEach(function (row, i) {
          var on = i === openIndex;
          var btn = row.querySelector('[data-rda2-rw-q]');
          var body = row.querySelector('[data-rda2-rw-a]');
          var sign = row.querySelector('[data-rda2-rw-sign]');
          if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (body) body.hidden = !on;
          /* en dash U+2013 when open, plus when closed */
          if (sign) sign.textContent = on ? '–' : '+';
        });
        root.dataset.rda2RwOpen = String(openIndex);
      }

      rows.forEach(function (row, i) {
        var btn = row.querySelector('[data-rda2-rw-q]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          paint(Number(root.dataset.rda2RwOpen) === i ? -1 : i);
        });
      });

      paint(0);
      root.rda2RwOpen = paint;
    });
  }

  /* ---- Sticky enrolment bar. Mobile only, and only across the educational middle.
     Shown when the hero has fully left the viewport AND the close CTA has not yet
     arrived, so it never sits over the accordion controls at rest: by the time the
     questions are fully scrolled, the close section has claimed the bar.
     rAF-throttled; the listener is passive AND capturing, so it still fires if the
     theme scrolls an inner container rather than the window. */
  function sticky(scope) {
    scope.querySelectorAll('[data-rda2-rw-sticky]').forEach(function (bar) {
      if (bar.dataset.rda2RwBound) return;
      bar.dataset.rda2RwBound = '1';

      var ticking = false;

      function measure() {
        ticking = false;
        var h = window.innerHeight || 0;
        if (window.innerWidth >= 760) { bar.classList.remove('is-on'); return; }

        var hero = document.getElementById(bar.getAttribute('data-hero') || 'rewards');
        var join = document.getElementById(bar.getAttribute('data-join') || 'join');

        /* Degrade rather than vanish if a merchant hides or reorders a section:
           with no hero anchor, fall back to a plain scroll threshold; with no
           close anchor, there is nothing for the bar to resolve into, so the
           second gate simply passes. */
        var past = hero
          ? hero.getBoundingClientRect().bottom < 0
          : (window.pageYOffset || document.documentElement.scrollTop || 0) > h * 0.6;
        var before = join ? join.getBoundingClientRect().top > h * 0.92 : true;

        bar.classList.toggle('is-on', past && before);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(measure);
      }

      window.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll);
      bar._rda2RwMeasure = measure;
      measure();
      /* One late pass: Aurora's app blocks and images can still be settling, and
         a layout shift after mount would leave the bar in the wrong state. */
      setTimeout(measure, 300);
    });
  }

  function init(scope) {
    scope = scope || document;
    faq(scope);
    sticky(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Selecting a question block in the theme editor should open that question. */
  document.addEventListener('shopify:block:select', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('[data-rda2-rw-row]') : null;
    var root = row && row.closest('[data-rda2-rw-faq]');
    if (!row || !root || !root.rda2RwOpen) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-rda2-rw-row]'));
    root.rda2RwOpen(rows.indexOf(row));
  });
})();